import { Component, CSSProperties } from 'react'
import { IWifiScanResult, WifiAuthMode, WifiCipherType } from '../../api/0x0001/wificonfig'
import Loader from '../loader'
import WifiUnusableSvg from '../../static/wifi_unusable.svg'
import WifiBadSvg from '../../static/wifi_bad_signal.svg'
import WifiOkaySvg from '../../static/wifi_okay_signal.svg'
import WifiGoodSvg from '../../static/wifi_good_signal.svg'
import WifiAmazingSvg from '../../static/wifi_amazing_signal.svg'
import { appRef, Theme } from '../../app'
import classnames from 'classnames'
import { HiLockOpen, HiLockClosed } from 'react-icons/hi'
import { getString, getLocale } from '../../locale'
import PasswordInput from '../password-input'

type Props = {
    items?: IWifiScanResult[]
    password?: string
    onPassChange: (value: string) => void
    onSsidChange: (value: string) => void
}

type State = {
    checked?: IWifiScanResult
}

class WifiList extends Component<Props, State> {
    state: State = {}

    render() {
        const { items } = this.props
        if (items === undefined) return <Loader size={12} className="mt-3" innerClassName="mx-auto" />
        return <div className="ltr mt-3">{items.map(this.renderItem.bind(this))}</div>
    }

    renderItem(item: IWifiScanResult, index: number) {
        const { checked } = this.state
        const isChecked = checked?.ssid === item.ssid
        return (
            <div
                key={index}
                onClick={() => {
                    this.props.onSsidChange(item.ssid)
                    this.props.onPassChange('')
                    this.setState({ checked: item })
                }}
                className={classnames(
                    'flex flex-wrap items-center px-5 py-2 hover:bg-gray-200 dark:hover:bg-gray-600 cursor-pointer border-gray-500 border-t first:border-t-0',
                    isChecked && 'bg-gray-200 dark:bg-gray-600',
                )}
            >
                <div className="relative">
                    {this.renderIcon(item)}
                    {this.renderLock(item)}
                </div>
                <div className="text-2xl dark:text-white ms-5 flex-grow">{item.ssid}</div>
                <div className="flex flex-col text-gray-500 w-full md:w-4/12">
                    <div>Group Cipher: {WifiCipherType[item.groupCipher as WifiCipherType]}</div>
                    <div>Pairwise Cipher: {WifiCipherType[item.pairwiseCipher as WifiCipherType]}</div>
                </div>
                {isChecked && this.renderPassword()}
            </div>
        )
    }

    renderPassword() {
        if (this.state.checked!.authmode === WifiAuthMode.Open) return undefined
        return (
            <div className={classnames('w-full mb-3', getLocale() === 'he' && 'rtl')}>
                <label className="dark:text-white text-sm">{getString('wificonfig.sta_pass')}</label>
                <PasswordInput className="pretty-input" value={this.props.password || ''} onChange={this.props.onPassChange} />
            </div>
        )
    }

    renderLock(item: IWifiScanResult) {
        const style: CSSProperties = {
            position: 'absolute',
            left: '50%',
            top: 0,
            transform: 'translate(-50%, 0.5em)',
        }
        return item.authmode === WifiAuthMode.Open ? (
            <HiLockOpen size={20} style={style} className="dark:text-white" />
        ) : (
            <HiLockClosed size={20} style={style} className="dark:text-white" />
        )
    }

    renderIcon(item: IWifiScanResult) {
        return (
            <div
                style={{
                    height: 80,
                    overflow: 'hidden',
                }}
            >
                <img className={classnames(appRef.state.theme === Theme.Dark && 'invert-filter')} src={getWifiIcon(item.rssi)} alt="" width={80} />
            </div>
        )
    }
}

function getWifiIcon(rssi: number): string | undefined {
    if (rssi >= -30) return WifiAmazingSvg
    if (rssi >= -67) return WifiGoodSvg
    if (rssi >= -70) return WifiOkaySvg
    if (rssi >= -80) return WifiBadSvg
    if (rssi >= -90) return WifiUnusableSvg
    return undefined
}

export default WifiList
